// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[3].use[1]!../../../../styles/colors.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.c7rGIUGY_YHPg_gH3_CT {
  line-height: 46px;
  padding: 0 16px;
  background: white;
  border: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["hc-outline"]};
  border-radius: 4px;
  /* slightly slarger than spec but easier to read and centers better */
  font-size: 15px;
  width: 100%;
}

select.c7rGIUGY_YHPg_gH3_CT {
  -moz-appearance: none;
  -webkit-appearance: none;
  cursor: pointer;
  background: url('https://s3.amazonaws.com/hc-images2/dropdown_arrow.png') no-repeat right;
  background-size: 24px 5px;
}

select.c7rGIUGY_YHPg_gH3_CT[disabled] {
    background-color: #eeeeee;
}

.c7rGIUGY_YHPg_gH3_CT.NlzmqG2pArTfhp6mmhGh {
  line-height: 30px;
  padding: 0px 8px;
  font-size: 13px;
}

.c7rGIUGY_YHPg_gH3_CT:placeholder {
  color: #777679;
}

.c7rGIUGY_YHPg_gH3_CT:focus {
  outline: none;
  border: 1px solid #2FB5C7 !important;
  box-shadow: 0 0 0 2px rgba(91, 99, 254, 0.1)
}

.c7rGIUGY_YHPg_gH3_CT.Nd88gM6O33HD9K0gv9Ib, ._lT431Y8I6IYcR5EAamA {
  border: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["hc-error"]};
}

/* wrapper around an input, label, and error status */
.ea3IaG_KaTjoFAxjfYf8 {
  margin-bottom: 20px;
}

.QRIhR8o5qRB8alwZOXEe {
  font-size: 14px;
  line-height: 18px;
  color: #32445A;
  font-weight: 600;
}

.QRIhR8o5qRB8alwZOXEe.Nd88gM6O33HD9K0gv9Ib, .ybOsSkg5DswPChxXxrv_ {
  margin-left: 10px;
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["hc-error"]};
  font-weight: 400;
}`, "",{"version":3,"sources":["webpack://./src/components/haven-design/form/inputs/input.module.css"],"names":[],"mappings":"AAGA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,8DAA4B;EAC5B,kBAAkB;EAClB,qEAAqE;EACrE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,eAAe;EACf,yFAAyF;EACzF,yBAAyB;AAC3B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC;AACF;;AAEA;EACE,8DAA0B;AAC5B;;AAEA,qDAAqD;AACrD;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mDAAe;EACf,gBAAgB;AAClB","sourcesContent":["@value colors: \"../../../../styles/colors.module.css\";\n@value hc-outline, hc-error from colors;\n\n.input {\n  line-height: 46px;\n  padding: 0 16px;\n  background: white;\n  border: 1px solid hc-outline;\n  border-radius: 4px;\n  /* slightly slarger than spec but easier to read and centers better */\n  font-size: 15px;\n  width: 100%;\n}\n\nselect.input {\n  -moz-appearance: none;\n  -webkit-appearance: none;\n  cursor: pointer;\n  background: url('https://s3.amazonaws.com/hc-images2/dropdown_arrow.png') no-repeat right;\n  background-size: 24px 5px;\n}\n\nselect.input[disabled] {\n    background-color: #eeeeee;\n}\n\n.input.small {\n  line-height: 30px;\n  padding: 0px 8px;\n  font-size: 13px;\n}\n\n.input:placeholder {\n  color: #777679;\n}\n\n.input:focus {\n  outline: none;\n  border: 1px solid #2FB5C7 !important;\n  box-shadow: 0 0 0 2px rgba(91, 99, 254, 0.1)\n}\n\n.input.error, .inputError {\n  border: 1px solid hc-error;\n}\n\n/* wrapper around an input, label, and error status */\n.inputGroup {\n  margin-bottom: 20px;\n}\n\n.label {\n  font-size: 14px;\n  line-height: 18px;\n  color: #32445A;\n  font-weight: 600;\n}\n\n.label.error, .labelError {\n  margin-left: 10px;\n  color: hc-error;\n  font-weight: 400;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colors": `"../../../../styles/colors.module.css"`,
	"hc-outline": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["hc-outline"]}`,
	"hcOutline": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["hc-outline"]}`,
	"hc-error": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["hc-error"]}`,
	"hcError": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["hc-error"]}`,
	"input": `c7rGIUGY_YHPg_gH3_CT`,
	"small": `NlzmqG2pArTfhp6mmhGh`,
	"error": `Nd88gM6O33HD9K0gv9Ib`,
	"inputError": `_lT431Y8I6IYcR5EAamA`,
	"inputGroup": `ea3IaG_KaTjoFAxjfYf8`,
	"label": `QRIhR8o5qRB8alwZOXEe`,
	"labelError": `ybOsSkg5DswPChxXxrv_`
};
export default ___CSS_LOADER_EXPORT___;
